<template>
    <ul v-loading="waitPost" class="input-ul">
        <li v-show="showTitle === true">
            <commonInputsTitle>添加通訊錄</commonInputsTitle>
        </li>

        <li>
            <el-input v-model="submitObj.addinfo1" show-word-limit maxlength="60" placeholder="用戶名稱(必填)" clearable />
        </li>

        <li>
            <el-input v-model="submitObj.addinfo2" show-word-limit maxlength="60" placeholder="用戶郵箱(必填)" clearable />
        </li>

        <li>
            <el-input v-model="submitObj.addinfo3" show-word-limit maxlength="60" placeholder="用戶電話" clearable />
        </li>

        <li>
            <el-input v-model="submitObj.addinfo4" show-word-limit maxlength="60" placeholder="公司名稱" clearable />
        </li>

        <li>
            <el-button @click="clickSubmitBtn" color="#6300BF" type="primary" size="large">保存</el-button>
        </li>
    </ul>
</template>

<script setup>
    import {ref, toRef, reactive} from "vue";
    import {useUserinfo} from "@/stores/userinfo";
    import util from "@/util/util"
    import api from "@/request/api"
    import commonInputsTitle from "@/components/commonInputsTitle"

    const emits = defineEmits(['submit-success'])

    //響應機制的userinfo
    const userInfoRef = toRef(useUserinfo())

    //是否在加載
    const waitPost = ref(false)

    //是否顯示標題
    const showTitle = ref(false)

    const submitObj = reactive({
        addinfo1: "",
        addinfo2: "",
        addinfo3: "",
        addinfo4: "",
    })

    const dataObj = {
        addinfo1: "",
        addinfo2: "",
        addinfo3: "",
        addinfo4: "",
        companycode: userInfoRef.value.companycode,
        login: userInfoRef.value.login
    }

    function clickSubmitBtn() {
        if (util.isEmpty(submitObj.addinfo1)){
            util.alertWarning("請輸入用戶名稱")
            return
        }

        if (util.isEmpty(submitObj.addinfo1)){
            util.alertWarning("請輸入用戶郵箱")
            return
        }

        submitData()
    }

    function submitData() {
        waitPost.value = true

        dataObj.addinfo1 = submitObj.addinfo1
        dataObj.addinfo2 = submitObj.addinfo2
        dataObj.addinfo3 = submitObj.addinfo3
        dataObj.addinfo4 = submitObj.addinfo4

        api.insertAdditionalrecord9.send(dataObj, submitCallback)
    }

    function submitCallback(res) {
        waitPost.value = false

        if (res.code === 200){
            util.alertSuccess("保存成功")

            submitObj.addinfo1 = ""
            submitObj.addinfo2 = ""
            submitObj.addinfo3 = ""
            submitObj.addinfo4 = ""

            emits("submit-success")
        }else{
            util.alertError(res.msg)
        }

    }

</script>

<style scoped>
    .input-ul {
        list-style: none;
        padding-left: 0;
    }

    .input-ul li {
        margin-bottom: 20px;
    }
</style>